export const OFFICIAL_EMAIL_FALLBACK =
  'This should be your official student email, eg. **you@school.edu**'
